import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import * as actions from '../store/actions/fecal-scoring.actions';

@Injectable({
  providedIn: 'root',
})
export class FecalScoringGuard {
  constructor(private readonly store: Store<RootState>) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(actions.getFecalScoringsRequest());
    return of(true);
  }
}
